import * as XLSX from 'xlsx'
import { ADICIONAIS_BOOLEAN, ADICIONAIS_QUANTIDADE } from '../data/adicionais'

function formatCurrency(value) {
  return Number(value || 0)
}

const FORMAS_LABEL = {
  pix: 'Pix', dinheiro: 'Dinheiro', credito: 'Cartão de crédito', debito: 'Cartão de débito',
}
const PRAZOS_LABEL = {
  ato: 'Tudo no ato', '50_50': '50% pedido + 50% na entrega',
}

function adicionaisResumidos(adicionais) {
  if (!adicionais) return ''
  const partes = []
  if (adicionais.puxadorTipo) {
    if (adicionais.puxadorTipo === 'Sem puxador') {
      partes.push('Sem puxador')
    } else {
      const cor = adicionais.puxadorCor ? ` ${adicionais.puxadorCor}` : ''
      const qtd = adicionais.puxadorQtd > 0 ? ` (${adicionais.puxadorQtd}x)` : ''
      partes.push(`Puxador ${adicionais.puxadorTipo}${cor}${qtd}`)
    }
  }
  ADICIONAIS_BOOLEAN.forEach(({ key, label }) => {
    if (adicionais[key]) partes.push(label)
  })
  ADICIONAIS_QUANTIDADE.forEach(({ key, label }) => {
    if (adicionais[key] > 0) partes.push(`${label}: ${adicionais[key]}`)
  })
  return partes.join(' | ')
}

export function exportarPlanilha(pedidos) {
  const wb = XLSX.utils.book_new()

  // ── Aba 1: Resumo de pedidos ──────────────────────────────────────────────
  const resumoHeader = [
    'Nº Pedido', 'Data', 'Cliente', 'Documento', 'Contato', 'Email',
    'Endereço', 'Prazo', 'Qtd Móveis', 'Valor Total (R$)', 'Status',
    'Vendedora', 'Forma Pagamento', 'Condição Pagamento',
  ]
  const resumoRows = pedidos.map(p => {
    const prazoLabel = p.prazoPagamento === 'custom'
      ? p.prazoPagamentoCustom || 'Personalizado'
      : PRAZOS_LABEL[p.prazoPagamento] || p.prazoPagamento || ''
    return [
      p.numero,
      p.criadoEm ? new Date(p.criadoEm).toLocaleDateString('pt-BR') : '',
      p.cliente?.nome || '',
      p.cliente?.documento || '',
      p.cliente?.contato || '',
      p.cliente?.email || '',
      p.cliente?.endereco || '',
      p.prazo ? new Date(p.prazo + 'T12:00:00').toLocaleDateString('pt-BR') : '',
      p.moveis?.length || 0,
      formatCurrency(p.valorTotal),
      p.status?.replace('_', ' ') || '',
      p.vendedora || '',
      FORMAS_LABEL[p.formaPagamento] || p.formaPagamento || '',
      prazoLabel,
    ]
  })
  const wsResumo = XLSX.utils.aoa_to_sheet([resumoHeader, ...resumoRows])
  wsResumo['!cols'] = [10,12,28,16,16,24,32,12,10,16,14,14,18,24].map(w => ({ wch: w }))
  estilosResumo(wsResumo, resumoRows.length)
  XLSX.utils.book_append_sheet(wb, wsResumo, 'Pedidos')

  // ── Aba 2: Itens detalhados ───────────────────────────────────────────────
  const itensHeader = [
    'Nº Pedido', 'Cliente', 'Vendedora', 'Status', 'Prazo',
    'Modelo', 'Cor', 'Compr. (cm)', 'Alt. (cm)', 'Prof. (cm)',
    'Adicionais', 'Observações', 'Preço (R$)',
  ]
  const itensRows = []
  pedidos.forEach(p => {
    p.moveis?.forEach(m => {
      itensRows.push([
        p.numero,
        p.cliente?.nome || '',
        p.vendedora || '',
        p.status?.replace('_', ' ') || '',
        p.prazo ? new Date(p.prazo + 'T12:00:00').toLocaleDateString('pt-BR') : '',
        m.modelo || '',
        m.cor || '',
        m.comprimento || '',
        m.altura || '',
        m.profundidade || '',
        adicionaisResumidos(m.adicionais),
        m.observacoes || '',
        formatCurrency(m.preco),
      ])
    })
  })
  const wsItens = XLSX.utils.aoa_to_sheet([itensHeader, ...itensRows])
  wsItens['!cols'] = [10,24,14,14,12,38,16,10,10,10,40,28,14].map(w => ({ wch: w }))
  XLSX.utils.book_append_sheet(wb, wsItens, 'Itens')

  XLSX.writeFile(wb, `Pedidos_MINI_${new Date().toISOString().split('T')[0]}.xlsx`)
}

export function exportarPedidoXlsx(pedido) {
  exportarPlanilha([pedido])
}

function estilosResumo(ws, nRows) {
  // Freeze header row
  ws['!freeze'] = { xSplit: 0, ySplit: 1 }
  ws['!autofilter'] = { ref: `A1:K1` }
  _ = nRows // used in future cell styling if needed
}

// eslint-disable-next-line no-unused-vars
let _ = null
